<template>

  <div class="bg">
      <div class="wimg-c" v-if="info"><img :src="info.subscribe_code_img" width="100%"></div>


  <div class="body">
    <van-cell-group v-show="showInfo" inset style=" margin-bottom: 20px;">
      <van-cell title="中奖信息" v-if="have" :value="have.have.name + (have.status == 1?have.have.red_amount == 0?'':'（已发放）':'(待发放)')" />
    </van-cell-group>
    <div class="content">
      
      <div class="rule" style="">
        <p>抽奖时间：3月4日10：00——3月6日23：59</p>
      </div>
    </div>
    <div class="grades_bg">
      <van-overlay :show="show" >
        <div class="wapp">
        <LuckDraw
        v-model="currIndex"
        :awards="awards"
        :textFontSize="textFontSize"
        @start="handleStart"
        @end="handleEnd"
        />
        </LuckDraw>
        </div>
      </van-overlay>

    </div>

  </div>
  <Bottom :active="3"></Bottom>
  </div>
	
</template>
<script>
import { getUserInfo,setUserInfo } from '@/api/user'
import { Toast } from 'vant'
import { gongweiChoujiang, lingqu } from '../api/vote'
import Bottom from './bottom'

export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            username:'',
            mobile:'',
            show: false,
            showInfo: false,
            textFontSize: '22px',
            currIndex: 3, // 奖品的索引
            awards: [     // 奖品
                { name: '10元', color: '#f8d494' },
                { name: '5元', color: '#f9e3bb' },
                { name: '2元', color: '#f8d494' },
                { name: '谢谢参与', color: '#f9e3bb' }
                
            ],
            chou_num: 0,
            have: false
        }
    },
    components: {
      Bottom
    },
    created(e) {
      this.$toast.loading({
            message: '加载中...',
            forbidClick: false,
            loadingType: 'spinner',
            duration: 10000
      });
    	gongweiChoujiang().then(res=> {
        this.$toast.clear()
        if(!res) {
          return
        }
        if(res.code && res.code != 200) {
          this.$dialog.alert({
              message: res.message,
              confirmButtonText: '确定'
          })
          return
        }
        //已经中奖的
        if(res.have) {
          this.showInfo = true
          this.show = false
          this.have = res
          if(res.have.red_amount > 0 && res.status == 0) {
            this.$dialog.alert({
              message: '您已经中奖《'+res.have.name+'》，如果没有发放，请耐心等待！',
              confirmButtonText: '确定'
            })
          }
          return
        }
        res = res.redbag.info
        if(res.code == 1) {//中奖
          this.show = true
          this.currIndex = res.index
          this.have = {have: res.result, status: 0}
        }else{
          this.currIndex = 3
          this.show = true
        }
      })
    },
    methods: {
      handleStart () {
        console.log('开始抽奖 ')
      },
      handleEnd (index) {
         let msg = ''
          let text = ''
          if(this.currIndex >= 3){
            msg = '谢谢参与！'
            text= '确定'
          }else{
            msg = '恭喜您，抽得' + this.awards[this.currIndex].name
            text= '立刻领取'
          }
          this.$dialog.alert({
            message: msg,
            confirmButtonText: text
          }).then(res=>{
            this.show = false
            this.showInfo = true
            lingqu().then(res=> {
              if(this.currIndex < 3){
                this.$dialog.alert({
                  message: '领取成功！系统稍后会发放现金红包，请耐心等待！',
                  confirmButtonText: '确定'
                })
              }
            })
            
            
          })
        
      }
     
    }
}
</script>
<style>
  .bg{
    background: #eee;
  }
  .body{
    width: 100%;
    height: 100vh;
    background: #fff;

  }
  .content {
    width: 100%;
    height: 100vh;
    background: url(http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/b0ea8f4227de4a64db0532da08b8d47d.png) no-repeat center bottom;
    background-size: 100% auto;

  }
  .content .title{
    line-height: 3em;
    text-align: center;
    color: #fff;
    font-size: 1.6em;
    border-bottom: 1px solid #134de1;
    text-indent: -1em;
  }
  .content .title span{
    float: left;
    font-size: 1em;
    color: #134de1;
    text-indent: 0em;
  }
  .info{
    width: 80%;
    margin: auto;
    border-radius: 10px;
    overflow: hidden;
    padding: 5vh 2vh;
    background: #fff;
  }
  .tit{
    font-size: 1.2em;
    line-height: 2em;
    font-weight: bold;
    text-indent: 1em;
  }
  .img img{
    width: 100%;
  }
  .name , .phone{
    position: relative;
  }
  .name .img{
    width: 30px;
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .phone .img{
  width: 30px;
  position: absolute;
    right: 0;
    bottom: 10px;
  }
  .button{
    background: url(http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/0e6c3fdf9fb377b3683e33241dd2812d.png);
    border: none;
    background-size: 100% 100%;
    width: 150px;
    margin: auto;
    padding-bottom: 8px; 
  }
  .rule{
    
    font-size: 1em;
    line-height: 1.5em;
    width: 80%;
    margin: auto;
    padding-top: 30px;
  }
  .share{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 30;
    background: rgba(0,0,0,0.5);
  }
.wapp{
    position: relative;
    top: 20%;
    margin: 20px auto;
    width:85vw;
}
.wapp canvas{ margin: 0 auto;width: 100%;height: 100%;}

</style>
